import(/* webpackMode: "eager" */ "D:\\Aarav\\Projects\\relaxing-routine\\app\\become-instructor\\page.tsx");
